import React, { useEffect, useContext } from 'react'
import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'
import history from '../../../../../history'
import { AmplitudeContext } from '@homebot/shared-util-quartermaster'

// Actions
import { clientSnoozeAvmHotMarket } from '../../../../../actions/client'

// // Components
import ThumbsUpAndDownOption from './ThumbsUpAndDownOption'

// // Selectors
import { hasCustomerToken } from '../../../../../auth'

// // Utils
import { OVERLAY_HELPERS } from '../../../../../constants/navigation'
import { dispatchEvent } from '../../../../../helpers/tagManager'
import {
  HotMarketWarningLoad,
  HotMarketWarningThumbsUpClick,
  HotMarketWarningThumbsDownClick,
} from '../../../../../constants/trackingEvents'

const propTypes = { setForceHide: PropTypes.func }

const AvmHotMarketToolTipWarning = ({ setForceHide }) => {
  const dispatch = useDispatch()
  const { ampli } = useContext(AmplitudeContext)

  const handleLooksGood = () => {
    setForceHide(true)
    if (hasCustomerToken()) return

    dispatchEvent(HotMarketWarningThumbsUpClick)
    dispatch(clientSnoozeAvmHotMarket())
    ampli?.avmFeedback({ avm_alert_response: 'avm_thumbs_up' })
  }

  const handleThumbsDown = () => {
    setForceHide(true)

    history.push(OVERLAY_HELPERS.avmHotMarketWarning.buildPath())

    if (hasCustomerToken()) return

    dispatchEvent(HotMarketWarningThumbsDownClick)
    dispatch(clientSnoozeAvmHotMarket())
    ampli?.avmFeedback({ avm_alert_response: 'avm_thumbs_down' })
  }

  useEffect(() => {
    dispatchEvent(HotMarketWarningLoad)
    ampli?.avmAlertViewed({ avm_alert_type: 'avm_alert_in_demand' })
  }, [ampli])

  return (
    <ThumbsUpAndDownOption
      handleThumbsUpClick={handleLooksGood}
      handleThumbsDownClick={handleThumbsDown}
    />
  )
}

AvmHotMarketToolTipWarning.propTypes = propTypes

export default AvmHotMarketToolTipWarning
